import { Modal as MantineModal } from '@mantine/core';

export const Modal = MantineModal.extend({
	defaultProps: {
		variant: 'primary',
		overlayProps: {
			transitionProps: {
				duration: 200,
				timingFunction: 'ease-in-out',
			},
		},
		transitionProps: {
			transition: {
				transitionProperty: 'transform, opacity',
				in: { transform: 'scale(1)', opacity: 1 },
				out: { transform: 'scale(0)', opacity: 0 },
			},
			duration: 200,
			timingFunction: 'ease-in-out',
		},
		trapFocus: true,
		returnFocus: false,
	},
});
